<template>
 <v-layout row fluid wrap class="card-margin-fix"  v-if="bucketGroup">
          <BucketTile v-for="bucket in bucketGroup.buckets" :key="bucket.id" :bucket="bucket" :groupCaseTypeId="bucketGroup.caseTypeId" :groupCaseTypeCode="bucketGroup.caseTypeCode" :permissions="permissions" :show-statistics="true"></BucketTile>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import BucketTile from '@/components/buckets/bucket-elements/BucketTile'

export default {
  name: "BucketGroup",
  props: ["bucketGroupId"],
  components: { BucketTile },
  computed: {
    ...mapState({
      caseTypes: state => state.caseTypes.all,
      permissions: state => state.ui.grantedPermissions      
    }),
    bucketGroup() {
      if (!this.bucketGroupId || !this.caseTypes) {
        return undefined
      }
      let bucketGroup
      this.caseTypes.forEach(caseType => {
        const groups = caseType && caseType.bucketGroups
        if (!groups) {
          return
        }
        groups.forEach(currentGroup => {
          if (currentGroup.id === this.bucketGroupId) {
            bucketGroup = currentGroup
            bucketGroup.caseTypeId = caseType.id
            bucketGroup.caseTypeCode = caseType.code
          }
        })
      })
      return bucketGroup
    }
  }
}
</script>
